// extracted by mini-css-extract-plugin
export default {"container":"splitSidebarView__container___eX1rr","resizer":"splitSidebarView__resizer___pGZ7H"};